import { useState } from "react";
import { Col, Card } from "react-bootstrap";
import { useRoleContext } from "./Providers/RoleProvider";

const InfoTP2 = () => {
  const { isAdmin } = useRoleContext();
  const [isCollapsed, setIsCollapsed] = useState(true);
  const infoWidth = isCollapsed ? 40 : 225;

  const rowStyle = {
    height: "32px",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    padding: 0,
    margin: 0,
    lineHeight: "1",
    whiteSpace: "nowrap",
    boxSizing: "border-box",
  };

  return (
    <Card
      className="ps-1 pt-2 pe-0 pb-2"
      style={{
        width: `${infoWidth}px`,
        flexShrink: 0,
        overflow: "hidden",
      }}
      onClick={() => setIsCollapsed((prev) => !prev)}
    >
      <Card.Body className="ps-0 pe-1 pb-0">
        {/* CIRCUIT */}
        <div className="info-section">
          <Col sm={1} className="newSidwaysDiv">
            Circuit
          </Col>
          <div>
            <div style={rowStyle}>Vendor Id</div>
            <div style={rowStyle}>Status / Use</div>
            <div style={rowStyle}>Type</div>
            <div style={rowStyle}>Category</div>
            {/* <div style={rowStyle}>Scope</div> */}
          </div>
        </div>

        {/* CARRIER */}
        <div className="info-section">
          <Col sm={1} className="newSidwaysDiv">
            Carrier
          </Col>
          <div>
            <div style={rowStyle}>Carrier</div>
            <div style={rowStyle}>LEC</div>
            <div style={rowStyle}>Access Bandwidth</div>
            <div style={rowStyle}>Port Bandwidth</div>
            <div style={rowStyle}>Handoff Type</div>
            <div style={rowStyle}>Redundancy Type</div>
            <div style={rowStyle}>Diversity</div>
          </div>
        </div>

        {/* DELIVERY */}
        <div className="info-section">
          <Col sm={1} className="newSidwaysDiv">
            Delivery
          </Col>
          <div>
            <div style={rowStyle}>Forecast Delivery</div>
            <div style={rowStyle}>Actual Handover</div>
            <div style={rowStyle}>Cutover</div>
            <div style={rowStyle}>Requested Disconnect</div>
          </div>
        </div>

        {/* BILLING */}
        <div className="info-section">
          <Col sm={1} className="newSidwaysDiv">
            Billing
          </Col>
          <div>
            <div style={rowStyle}>Billing Started</div>
            <div style={rowStyle}>Billing Stopped</div>
            <div style={rowStyle}>Current Term End</div>
            {isAdmin && <div style={rowStyle}>Currency</div>}
            {isAdmin && <div style={rowStyle}>Bill To Country</div>}
            {isAdmin && <div style={rowStyle}>MRC (USD)</div>}
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default InfoTP2;
